import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { UserPlus, X } from 'lucide-react';
import { useTheme } from '../../context/ThemeContext';

/**
 * Link component to trigger the On Behalf Of modal
 * Only visible for admin users
 */
const OnBehalfButton = ({ user, onClick, onCancel}) => {
  const { theme } = useTheme();
  const isDark = theme === 'dark';

  const linkClassName = clsx(
    'inline-flex items-center gap-1.5 text-sm font-medium underline transition-colors',
    'focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 rounded',
    {
      'text-blue-600 hover:text-blue-700': !isDark,
      'text-blue-400 hover:text-blue-300 focus:ring-offset-slate-800': isDark
    }
  );

  const cancelLinkClassName = clsx(
    'inline-flex items-center text-sm font-medium underline transition-colors',
    'focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 rounded',
    {
      'text-red-600 hover:text-red-700': !isDark,
      'text-red-400 hover:text-red-300 focus:ring-offset-slate-800': isDark
    }
  );

  return (
    <>
      {user?.id && (
        <div className="flex items-center justify-around gap-2">
          <span>
            {'Currently booking for '}
            <a
              href={`/admin/users/${user.id}`}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:underline"
            >
              {user.email}
            </a>
          </span>
          <button
            onClick={onCancel}
            className={cancelLinkClassName}
            aria-label="Remove user from order"
          >
            <X size={18} />
          </button>
        </div>
      )}

      {!user?.id && (
        <button
          onClick={onClick}
          className={linkClassName}
          aria-label="Add user to order"
        >
          <UserPlus className="w-4 h-4" />
          <span>Add User to Order</span>
        </button>
      )}
    </>
  );
};

OnBehalfButton.propTypes = {
  /** Function called when link is clicked */
  onClick: PropTypes.func.isRequired,
  onCancel: PropTypes.func,
  /** Currently selected on behalf user */
  user: PropTypes.shape({
    id: PropTypes.string,
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    email: PropTypes.string
  })
};

export default OnBehalfButton;